export class HomeHelper {
	public readonly homeAnchors = {
		pricing: 'pricing',
		faqs: 'faqs',
		features: 'features',
		contact: 'contact',
		testimonials: 'testimonials',
		app: 'getapp'
	};
}

export const homeHelper = new HomeHelper();
